/**
 * @generated SignedSource<<e6810073d29b78e9da92e96dcfecc5f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemCarousel_baseItem$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly " $fragmentType": "PdpRespSimilarItemCarousel_baseItem";
};
export type PdpRespSimilarItemCarousel_baseItem$key = {
  readonly " $data"?: PdpRespSimilarItemCarousel_baseItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItemCarousel_baseItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItemCarousel_baseItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6fc5eb6063a17f91c7a4917eadb86024";

export default node;
